import { ComponentType } from "react";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ChildFriendlyOutlinedIcon from "@mui/icons-material/ChildFriendlyOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import LocalFloristOutlinedIcon from "@mui/icons-material/LocalFloristOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import LocalBarOutlinedIcon from "@mui/icons-material/LocalBarOutlined";
import MusicNoteOutlinedIcon from "@mui/icons-material/MusicNoteOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";

export type MomentIconOption = {
  /** The MaterialCommunityIcons name the app draws. Stored on the occasion. */
  value: string;
  label: string;
  /** Only used here, to show a preview in the admin. */
  Preview: ComponentType;
};

// The app draws `value` with @expo/vector-icons/MaterialCommunityIcons; the
// preview is the closest MUI icon, so the admin never needs to know icon names.
export const MOMENT_ICON_OPTIONS: MomentIconOption[] = [
  { value: "cake-variant", label: "Cake", Preview: CakeOutlinedIcon },
  {
    value: "heart-multiple",
    label: "Hearts",
    Preview: FavoriteBorderOutlinedIcon,
  },
  { value: "ring", label: "Ring", Preview: DiamondOutlinedIcon },
  { value: "school", label: "Graduation", Preview: SchoolOutlinedIcon },
  {
    value: "baby-carriage",
    label: "Baby",
    Preview: ChildFriendlyOutlinedIcon,
  },
  {
    value: "party-popper",
    label: "Party",
    Preview: CelebrationOutlinedIcon,
  },
  { value: "airplane", label: "Travel", Preview: FlightOutlinedIcon },
  { value: "home-heart", label: "Home", Preview: HomeOutlinedIcon },
  { value: "briefcase", label: "Work", Preview: WorkOutlineIcon },
  { value: "gift", label: "Gift", Preview: CardGiftcardOutlinedIcon },
  { value: "paw", label: "Pet", Preview: PetsOutlinedIcon },
  { value: "star", label: "Star", Preview: StarBorderIcon },
  { value: "trophy", label: "Trophy", Preview: EmojiEventsOutlinedIcon },
  { value: "flower", label: "Flower", Preview: LocalFloristOutlinedIcon },
  { value: "glass-wine", label: "Toast", Preview: LocalBarOutlinedIcon },
  { value: "music", label: "Music", Preview: MusicNoteOutlinedIcon },
  {
    value: "hand-heart",
    label: "Thank you",
    Preview: VolunteerActivismOutlinedIcon,
  },
  { value: "calendar-star", label: "Other", Preview: EventOutlinedIcon },
];
